export default "__VITE_ASSET__DpdczPcf__"